import React, { useEffect, useState } from 'react'

import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { KeyboardAwareScrollView } from '../Components'

import {
  Space,
  Description,
  CreditCardForm,
  RadioExtended,
  Text,
  Button,
  Price
} from '@sart/components'
import {
  CashIcon,
  Visa,
  MasterCard,
  AmericanExpress,
} from '@sart/icons'
import { adaptive, colors, typography } from '@sart/styles'
import client, { useClient, useData } from '@sart/client'
import { useContent } from '@sart/content'
import { testID } from '@sart/utilities'

export default function ProfileBilling(props) {
  const { navigation } = props
  const {
    cache: {
      storedPayment
    }
  } = useClient()
  const [{ settings, loading, error }, setData] = useData({ loading: true})
  const [price, setPrice] = useState(undefined)
  const optionSelected = 'creditCard'

  useEffect(() => {
    getPrice()
  }, [])

  const content = useContent()

  async function getPrice() {
    try {
      let tokeniseProducts = await client.callApi('catalog','getTokenizeCardProducts',[client.cache.catalogId])
      const tokeniseProduct = tokeniseProducts.find(
        product => product.productLegacyId === 'VALIDATE-PAYMENT-CARD'
      )
      setPrice(tokeniseProduct.upfrontCost)
    } catch(error) {

    }
  }

  function handleStoredCard(){
    navigation.navigate('ProfileHostedPayment')
  }
  
  return (
    <KeyboardAwareScrollView style={styles.container}>
      <View style={styles.wrapper}>
      {/* <Description style={styles.description}>{content.payment_method.instructions}</Description> */}

      <Space height={24} />

      <TouchableOpacity style={styles.section} disabled={loading} {...testID('cardOption')}>
        <View style={{flexDirection: 'row'}}>
          <RadioExtended
            label={content.payment_method.saveCardDetails}
            selected={optionSelected === 'creditCard'}
          />

          <Space flex />

          <Visa />
          <Space width={8} />
          <MasterCard />
          <Space width={8} />
          <AmericanExpress />
        </View>

        <Space height={12} />
        {price &&
          <Text>{content.payment_method.refundedPayment} {'£' + (price / 100).toFixed(2)} {content.payment_method.refundedPaymentTwo}</Text>
        }
      </TouchableOpacity>
      <Space height={24} />
      <Button
        style={styles.button}
        title={content.common.continue}
        onPress={handleStoredCard}
        titleStyle={{...typography.extrabold, fontSize: 18}}
        {...testID('cardOptionSelect')}
      />
      </View>
    </KeyboardAwareScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
    ...adaptive.wrapperPadding
  },
  wrapper: {
    paddingBottom: 24
  },
  enabled: {
    backgroundColor: colors.srGreyBackground
  },
  disabled: {
    backgroundColor: colors.srGreyBackground + 50
  },
  description: {
    textAlign: 'center',
    ...typography.bold
  },
  button: {
    backgroundColor: colors.srDarkGreen,
  },
  buttonTitle: {
    ...typography.extrabold,
    fontSize: 18,
  },
  section: {
    // paddingTop: 24,
    // paddingBottom: 24
  },
  creditCardFormInput: {
    ...typography.demi
  },
  creditCardFormLabel: {
    ...typography.demi
  }
})
